import createIcon from '../../createIcon';

/**
 * @component @name DirectionsRailway
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNCAxNi41QzQgMTguNDMgNS41NyAyMCA3LjUgMjBMNiAyMS41VjIySDE4VjIxLjVMMTYuNSAyMEMxOC40MyAyMCAyMCAxOC40MyAyMCAxNi41VjZDMjAgMi41IDE2LjQyIDIgMTIgMkM3LjU4IDIgNCAyLjUgNCA2VjE2LjVaTTEyIDE4QzEwLjkgMTggMTAgMTcuMSAxMCAxNkMxMCAxNC45IDEwLjkgMTQgMTIgMTRDMTMuMSAxNCAxNCAxNC45IDE0IDE2QzE0IDE3LjEgMTMuMSAxOCAxMiAxOFpNMTggMTFINlY2SDE4VjExWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DirectionsRailway = createIcon('DirectionsRailway', [
  [
    'path',
    {
      d: 'M4 16.5C4 18.43 5.57 20 7.5 20L6 21.5V22H18V21.5L16.5 20C18.43 20 20 18.43 20 16.5V6C20 2.5 16.42 2 12 2C7.58 2 4 2.5 4 6V16.5ZM12 18C10.9 18 10 17.1 10 16C10 14.9 10.9 14 12 14C13.1 14 14 14.9 14 16C14 17.1 13.1 18 12 18ZM18 11H6V6H18V11Z',
      key: 'pw7jzv',
    },
  ],
]);

export default DirectionsRailway;
